import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
  loadingMessage: string = '';

  ngOnInit(): void {
    // Delayed announcement to ensure screen readers pick it up
    setTimeout(() => {
      this.loadingMessage = 'Loading, please wait';
    }, 100);
  }

  ngOnDestroy(): void {
    // Clear message when loader is removed
    this.loadingMessage = '';
  }
}
